module.exports = __webpack_public_path__ + "img/writing.e8864735.jpeg";